import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import Chart from 'react-google-charts';

const ChequeBounce = () => {
  const data = [
    ['Month', 'Cheque Bounces'],
    ['January', 2],
    ['February', 1],
    ['March', 3],
    ['April', 2],
    ['May', 1],
  ];

  const options = {
    title: 'Cheque Bounces',
    hAxis: { title: 'Month' },
    vAxis: { title: 'Cheque Bounces' },
    legend: { position: 'top' },
    bar: { groupWidth: '75%' },
    colors: ['#F44336'],
  };

  return (
    <Col className="col-sm-12 col-xl-6 box-col-6">
      <Card>
        <CardBody>
          <Chart
            width={'100%'}
            height={'400px'}
            chartType="ColumnChart"
            loader={<div>Loading Chart...</div>}
            data={data}
            options={options}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

export default ChequeBounce;